import { useNavigate, createSearchParams, useSearchParams } from "react-router";
import { UseNavigateParamsReturn, URLQueryParams } from "../types";

const useNavigateParams = (): UseNavigateParamsReturn => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const getURLQueryParams = (): URLQueryParams => {
    const result: URLQueryParams = {};
    searchParams.forEach((value, key) => {
      result[key] = value;
    });
    return result;
  };

  const setQueryNavigation = (url: string, params: Record<string, string>): void => {
    const search = createSearchParams(params).toString();
    navigate({ pathname: url, search: `?${search}` });
  };

  return {
    setQueryNavigation,
    getURLQueryParams,
  };
};

export default useNavigateParams;
